<template>
  <div>
    <div class="zn-template-head">
      <span class="zn-template-title">新建项目</span>
      <span class="zn-text-grey">每个问题中 “ ” 里的的话术可以直接照着念，询问客户信息</span>
    </div>
    <div class="zn-template-content" ref="tplContent">
      <div v-loading="submiting"
        element-loading-text="努力解析中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
        <el-row :gutter="15">
          <el-col :span="12">
            <div class="zn-content-item-inline">
              <div class="zn-text-grey" style="width:70px"><span style="color:#f00">*</span>客户公司：</div>
              <el-autocomplete
                v-model="formData.客户公司"
                class="flex-1"
                size="mini"
                :fetch-suggestions="querySearch"
                placeholder="输入公司名称，点击选择"
                popper-class="companyhr-item"
                @select="handleSelectCompany"
                @change.native="handleCompanyChange"
                @input="handleCompanyInput"
                style="flex: 1"
              >
                <template slot-scope="{ item }">
                  <div v-if="item.value === '没找到，新建一家公司'" class="hr-add-btn">
                    <button type="button" class="el-button ml-10 el-button--text el-button--small"><span>+ 没找到，新建一家公司</span></button>
                  </div>
                  <span v-else class="ml-12">{{ item.value }}</span>
                </template>
              </el-autocomplete>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="zn-content-item-inline">
              <div class="zn-text-grey" style="width:70px"><span style="color:#f00">*</span>客户开发：</div>
              <el-select size="mini" v-model="formData.客户开发" filterable style="flex: 1">
                <el-option v-for="(a, k) in accounts" :key="k" :label="a" :value="a"></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="zn-content-item-inline">
              <div class="zn-text-grey" style="width:70px"><span style="color:#f00">*</span>岗位名称：</div>
              <el-autocomplete
                v-model="formData.项目名称" size="mini"
                :fetch-suggestions="jobNameQuerySearch"
                placeholder="输入岗位名称关键字"
                class="flex-1"
                @select="jobNameHandleSelect"
                style="flex: 1"
              >
              </el-autocomplete>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="zn-content-item-inline">
              <div class="zn-text-grey" style="width:70px">职能模块：</div>
              <el-select size="mini" v-model="formData.职能模块" filterable @change="changeCate" style="flex: 1">
                <el-option v-for="(c, k) in categories" :key="k" :label="c" :value="c"></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="zn-content-item-inline">
              <div class="zn-text-grey" style="width:80px"><span style="color:#f00">*</span>企业联系人：</div>
              <el-select
                v-model="formData.对接hrId"
                ref="hrselect"
                class="flex-1" :disabled="!formData.客户公司"
                size="mini"
                placeholder="请在下拉框中选择企业对接hr"
                filterable
                popper-class="companyhr-item"
                @focus="getCompanyHr"
                @change="handleSelectHr"
                style="flex: 1"
              >
                <el-option-group
                  v-for="group in company.ContactGroup"
                  :key="group.label"
                  :label="group.label">
                  <el-option
                    v-for="item in group.options"
                    :key="item._id"
                    :label="item.姓名"
                    :value="item._id">
                    <div class="flex">
                      <div class="mr-5">{{item.姓名}}</div>
                    </div>
                  </el-option>
                </el-option-group>
                <div class="hr-add-btn">
                  <button type="button" class="el-button ml-20 el-button--text el-button--small" @click="gotoAddHr"><span>+ 没找到，新建一个人</span></button>
                </div>
                <div slot="empty" class="hr-add-btn">
                  <span v-if="hrloading" class="text-gray-600 text-center">数据获取中</span>
                  <button v-else type="button" class="el-button ml-20 el-button--text el-button--small" @click="gotoAddHr"><span>+ 没找到，新建一个人</span></button>
                </div>
              </el-select>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="zn-content-item-inline">
              <div class="zn-text-grey" style="width:70px"><span style="color:#f00">*</span>工作地点：</div>
              <el-select size="mini" v-model="formData.地域" multiple filterable allow-create style="flex: 1">
                <el-option v-for="(di, k) in diYu" :key="k" :label="di" :value="di"></el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
        <div class="zn-content-item" v-for="(field, k) in fields" :key="k">
          <div v-if="field.label == '项目的亮点优势'" style="color: #F56C6C;padding:5px 0">填写亮点，核心要求，风险点可以快速有效的做项目分析和selling（三三一法则）</div>
          <div class="zn-text-grey">{{ field.label }}：</div>
          <el-input
            type="textarea"
            :rows="2"
            :placeholder="field.placeholder"
            v-model="formData[field.value]">
          </el-input>
        </div>
      </div>
    </div>
    <div class="zn-template-submit" @click="save" style="margin-left:-110px">完成填写</div>
    <div class="zn-template-submit" @click="submit" style="margin-left:10px">AI填写</div>

    <div class="zn-project-left" v-show="formData.客户公司">
      <div class="zn-template-head">
        <span class="zn-template-title">辅助建项数据展示</span>
        <span class="zn-text-grey">根据建项必填项自动展示对应数据供参考</span>
      </div>
      <el-tabs type="card" v-model="activeTabName">
        <el-tab-pane label="流入最多的公司" name="1">
          <el-row :gutter="20" v-loading="jingduiLoading">
            <el-col :span="12">
              <div class="text-gray-600 mb-10">流入人数最多的公司</div>
              <table class="simple-table" cellspacing="0" style="width:100%">
                <tr>
                  <th>#</th>
                  <th>公司</th>
                  <th>人数</th>
                </tr>
                <tr v-for="(item, k) in liuruList" :key="k">
                  <td>{{k+1}}</td>
                  <td>
                    <span v-if="item.cid" class="text-blue cursor-pointer font-14" @click="openCompany(item.cid)">{{item.简称}}</span>
                    <span v-else>{{item.name}}</span>
                  </td>
                  <td>
                    <span>{{item.count}}</span>
                  </td>
                </tr>
              </table>
            </el-col>
            <el-col :span="12">
              <div class="text-gray-600 mb-10">同排名上下的公司</div>
              <table class="simple-table" cellspacing="0" style="width:100%">
                <tr>
                  <th>#</th>
                  <th>公司</th>
                </tr>
                <tr v-for="(item, k) in paimingList" :key="k">
                  <td>{{k+1}}</td>
                  <td>
                    <span class="text-blue font-14" @click="openCompany(item._id)">{{item.简称}}</span>
                  </td>
                </tr>
              </table>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="过往成功推荐" name="2">
          <table cellspacing="0" style="width:100%;table-layout:fixed" class="cv-info-dia-table" v-loading="cvInfoLoading">
            <tr>
              <th style="width:60px">
                <span>候选人</span>
              </th>
              <th style="width:120px">已成功岗位</th>
              <th>人选基本信息</th>
              <th style="width:80px">成交数据</th>
            </tr>
            <tr v-for="(item, index) in temporaryCvInfo" :key="index">
              <td>
                <div class="flex items-center">
                  <div style="padding-left:5px">
                    <div class="a-link" @click.stop="showRadish(item._id)">{{item.姓名}}</div>
                  </div>
                </div>
              </td>
              <td class="text-center">
                <div style="padding:0 5px">{{item.项目名称}}</div>
              </td>
              <td>
                <div style="display: grid;grid-template-columns: 50% 20% 30%;grid-template-rows: 50% 50%;">
                  <div class="cv-info-dia-td-dot">
                    <span>职能模块：</span>
                    <div :title="getArrVal(item, '职能模块')">
                      {{getArrVal(item, '职能模块')}}
                    </div>
                  </div>
                  <div class="cv-info-dia-td-dot">
                    <span>业绩：</span>
                    <div :title="item.业绩 || ''">{{item.业绩 || ''}}</div>
                  </div>
                  <div class="cv-info-dia-td-dot">
                    <span>地域：</span>
                    <div :title="getArrVal(item, '地域')">
                      {{getArrVal(item, '地域')}}
                    </div>
                  </div>
                  <div class="cv-info-dia-td-dot">
                    <span>细分职能：</span>
                    <div :title="getArrVal(item, '细分职能')">
                      {{getArrVal(item, '细分职能')}}
                    </div>
                  </div>
                  <div class="cv-info-dia-td-dot">
                    <span>职级：</span>
                    <div :title="item.职级 || ''">{{item.职级 || ''}}</div>
                  </div>
                </div>
              </td>
              <td style="width:80px;text-align:center">
                <el-tooltip v-if="item.offer" placement="top">
                  <div slot="content">
                    候选人：{{item.offer.候选人 || '--'}}<br>
                    顾问：{{item.offer.顾问 || '--'}}<br>
                    职位：{{item.offer.职位 || '--'}}<br>
                    专业职级：{{item.offer.专业职级 || '--'}}<br>
                    固定年薪：{{item.offer.固定年薪 || '--'}}<br>
                    offer签订日期：{{item.offer.offer签订日期 || '--'}}<br>
                    预计到岗日期：{{item.offer.预计到岗日期 || '--'}}<br>
                    到岗时间：{{item.offer.到岗时间 || '--'}}<br>
                    备注：{{item.offer.备注 || '--'}}<br>
                  </div>
                  <div class="morandi-btn">
                    查看offer
                  </div>
                </el-tooltip>
              </td>
            </tr>
          </table>
        </el-tab-pane>
        <el-tab-pane label="薪酬" name="3">
          <el-tabs v-model="salaryActive" style="padding-bottom:10px">
            <el-tab-pane label="公司薪酬" name="com">
              <div class="title" style="padding-bottom:10px;font-weight:bold">公司整体薪酬表</div>
              <div v-if="company.companyMoneyTable" class="money-table-box" style="width:100%;margin-bottom:10px">
                <NewMoneyTable v-if="company.companyMoneyTable.content" :table="company.companyMoneyTable" :hideContent="true"></NewMoneyTable>
              </div>
              <div class="title" style="padding: 10px 0;font-weight:bold">职能模块薪酬表</div>
              <div v-if="!activeCateTablCate">暂无数据</div>
              <div v-else class="money-table-box mb10" style="width:100%">
                <el-tabs v-model="activeCateTablCate" type="card" @tab-click="chooseCate">
                  <el-tab-pane v-for="(value, key) in company.categoryMoneyTable" :key="key" :label="key" :name="key">
                  </el-tab-pane>
                </el-tabs>
                <NewMoneyTable v-if="activeCateTable.content" :table="activeCateTable" :hideContent="true"></NewMoneyTable>
              </div>
            </el-tab-pane>
            <el-tab-pane label="公司已有人员薪酬" name="comRadish">
              <div v-if="!company.简称">无公司</div>
              <RadishesMoney ref="RadishesMoney" v-else :companyName="company.简称"></RadishesMoney>
            </el-tab-pane>
          </el-tabs>
          <el-tabs v-model="salaryActive2" style="padding-bottom:10px">
            <el-tab-pane label="职能模块薪酬" name="cate">
              <CategoryMoney ref="CategoryMoney" :radish="{行业: company.行业, 职能模块: formData.职能模块}"></CategoryMoney>
            </el-tab-pane>
            <el-tab-pane label="同职能模块人选薪酬" name="cateRadish">
              <div v-if="!formData.职能模块">无职能模块</div>
              <RadishesMoney ref="RadishesMoney2" v-else :category="formData.职能模块"></RadishesMoney>
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
        <el-tab-pane label="客户公司情况" name="4">
          <div style="line-height:1.5">
            <div class="zn-text-grey" style="padding-left:5px">公司优势详情：</div>
            <pre style="padding:10px 20px;white-space: pre-wrap;margin:0">{{company.公司亮点 && company.公司亮点.content?company.公司亮点.content:'无'}}</pre>
            <div class="zn-text-grey" style="padding-left:5px">公司劣势详情：</div>
            <pre style="padding:10px 20px;white-space: pre-wrap;margin:0">{{company.公司劣势 && company.公司劣势.content?company.公司劣势.content:'无'}}</pre>
            <div class="zn-text-grey" style="padding-left:5px">职能模块认知：</div>
            <pre style="padding:10px 20px;white-space: pre-wrap;margin:0">{{cateRenzhi||'无'}}</pre>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import {diYu} from '../../../radish/src/constant/common-var.js'
import NewMoneyTable from '../../../company/src/component/NewMoneyTable'
import RadishesMoney from '../../../radish/src/components/radishes-money'
import CategoryMoney from '../../../radish/src/components/category-money'
export default {
  components: {NewMoneyTable, RadishesMoney, CategoryMoney},
  props: {
    componentName: String,
  },
  data() {
    return {
      formData: {地域:[]},
      diYu,
      categories: app.categories.map(category => category.名称) || [],
      accounts: app.accounts,
      fields: [
        {
          label: '岗位关键要求', value: '岗位描述和岗位要求',
          placeholder: '“ 这个职位大概扮演什么样的角色（职责），或者我们对这个人选最核心的要求是什么？ ”'
        },
        {
          label: '岗位薪酬', value: '岗位薪酬备注',
          placeholder: '“ 这个岗位我们一般的薪酬参考区间是多少？包括奖金？或：如果要管理候选人对薪酬的预期，你觉得什么范围比较好？ ”',
        },
        {
          label: '寻访方向', value: '寻访方向',
          placeholder: '“ 这个岗位最近会不会有领导看重但offer没谈成的人选，或者是最近这两年领导点过名想要看的人选，大概是什么平台什么背景？ ”',
        },
        {
          label: '项目的亮点优势', value: '项目亮点及优势',
          placeholder: '',
        },
        {
          label: '核心要求', value: '核心要求汇总',
          placeholder: '',
        },
        {
          label: '职位劣势及风险点', value: '职位劣势及风险点',
          placeholder: '“ 这个职位大概招了多长时？之前咱们领导看重的人选没来的原因是什么？ ”',
        },
        {
          label: '职位部门情况', value: '部门详情',
          placeholder: '',
        },
        {
          label: '职位产生的原因', value: '职位产生的原因',
          placeholder: '” 这个岗位咱们是新增还是替换？ ”',
        },
        {
          label: '最迟到岗日期', value: '最迟到岗日期',
          placeholder: '“ 最迟在什么时间之前一定要招到岗？ ”',
        },
        {
          label: '招聘难点', value: '招聘难点',
          placeholder: '',
        },
        {
          label: '竞争预警', value: '竞争预警',
          placeholder: '“ 这个岗位是刚刚开始招吗，还是已经找过一轮了，目前已经也同步放给其他猎头了吗？ ”',
        },
        {
          label: '面试流程', value: '面试流程',
          placeholder: '“这个岗位一般咱们会有多少轮面试，面试官一般是谁？ ”',
        },
      ],
      submiting: false,
      companies: null,
      inputCompany: '',
      company: {},
      hrloading: false,
      recommendCateObj: {},
      activeTabName: '1',
      cateRenzhi: '',

      jingduiLoading: false,
      liuruList: [],
      paimingList: [],
      temporaryCvInfo: [],
      cvInfoLoading: false,

      activeCateTable: {},
      activeCateTablCate: '',
      salaryActive: 'com',
      salaryActive2: 'cate',
    }
  },
  watch: {
    formData: {
      // 缓存到local
      handler: function (newVal) {
        // console.log('change', JSON.stringify(newVal))
        localStorage.setItem(this.componentName, JSON.stringify(newVal))
      },
      deep: true
    }
  },
  methods: {
    async querySearch(queryString, cb) {
      const results = queryString ? await this.searchCompanyName(queryString) : []
      cb(results)
    },
    async searchCompanyName(name) {
      name = name.trim()
      if (!name) return []
      const res = await app.service('company').serchCompany(name)
      const sliceArr = res.data.slice(0, 10)
      const isClient = sliceArr.filter(v => v.公司阶段 === '已签约')
      const isNotClient = sliceArr.filter(v => v.公司阶段 !== '已签约')
      const arr = []
      if (isClient.length > 0) {
        const companies = isClient.map(val => ({
          value: `${val.简称}${val.公司名称 ? `（${val.公司名称}）` : ''}${val.公司类型 ? `（${val.公司类型}）` : ''}${
            val.客户开发 ? `（${val.客户开发}）` : ''
          }`,
          简称: val.简称,
          company: val,
        }))
        arr.push(...companies)
      }
      if (isNotClient.length > 0) {
        const companies = isNotClient.map(val => ({
          value: `${val.简称}${val.公司名称 ? `（${val.公司名称}）` : ''}（非客户）`,
          简称: val.简称,
          company: val,
        }))
        arr.push(...companies)
      }
      this.companies = window._.cloneDeep(arr)
      arr.push({ value: '没找到，新建一家公司' })
      return arr
    },
    async getCompanyHr() {
      if (this.hrloading) return
      this.hrloading = true
      const { result } = await app.service('company').getCompany({ 简称: this.formData.客户公司 })
      // console.log(this.formData.客户公司, result)
      this.company = result
      const duijie = result ? result.对接hr : this.result.对接hr
      const zhixian = result ? result.直线联系人 : this.result.直线联系人
      let hrs = []
      let duijieIds = []
      let zhixianIds = []
      if (duijie && duijie.length > 0) {
        hrs = hrs.concat(duijie)
        duijieIds = duijie.map(hr => hr.rid)
      }
      if (zhixian && zhixian.length > 0) {
        hrs = hrs.concat(zhixian)
        zhixianIds = zhixian.map(hr => hr.rid)
      }
      const hrids = hrs.map(hr => hr.rid)
      // console.log(hrs)
      if (result.简称) {
        const cateRes = await app.service('radish').simpleList({
          query: { 公司: result.简称, 职能模块: 'HR-人力' },
          fields: { 姓名: 1, 手机: 1, 公司: 1, 部门: 1, 目前职位: 1, 职能模块: 1, 职级: 1, 业绩: 1 },
        })
        if (cateRes.status === 'success') {
          cateRes.data.forEach(item => {
            if (!hrids.includes(item._id)) {
              hrids.push(item._id)
            }
          })
        }
      }
      if (hrids.length > 0) {
        const res = await app.service('radish').listMore({ ids: hrids })
        this.company.企业对接联系人 = res.data.data.map(dt=>{
          if (duijieIds.includes(dt._id)) dt.type = '对接HR'
          if (zhixianIds.includes(dt._id)) dt.type = '业务直线'
          if (!duijieIds.includes(dt._id) && !zhixianIds.includes(dt._id)) dt.type = '其他'
          return dt
        })
        this.company.ContactGroup = [
          {
            label: '公司对接HR',
            options: this.company.企业对接联系人.filter(dt=>dt.type == '对接HR'),
          },
          {
            label: '公司业务直线',
            options: this.company.企业对接联系人.filter(dt=>dt.type == '业务直线'),
          },
          {
            label: '以下人选非该公司对接人',
            options: this.company.企业对接联系人.filter(dt=>dt.type == '其他'),
          }
        ]
      } else {
        this.company.企业对接联系人 = []
        this.company.ContactGroup = []
      }
      // console.log(this.company.企业对接联系人)
      this.hrloading = false
    },

    async handleSelectCompany(item) {
      if (item.value === '没找到，新建一家公司') {
        this.gotoAddCompany()
      } else {
        this.selectCompany(item)
      }
    },
    async selectCompany(item) {
      const { result } = await app.service('company').getCompany({ 简称: item.简称 })
      // console.log(result)
      this.company = result
      this.$set(this.formData, '客户开发', result.客户开发 || app.user.account)
      this.$set(this.formData, '客户公司', item.简称)
      this.loadCateRenzhi()
      this.loadJingDui()
      this.loadCvInfo()
      this.loadMoney()
      this.loadSalary()
    },
    handleCompanyChange() {
      if (this.companies.length > 0) {
        const matched = this.companies.find(c=>c.简称 == this.formData.客户公司)
        if (matched) {
          this.selectCompany(matched)
        } else {
          this.selectCompany(this.companies[0])
        }
      }
    },
    handleCompanyInput(value) {
      if (value != '没找到，新建一家公司') {
        this.inputCompany = value
      }
    },
    gotoAddHr() {
      if (!this.company._id) return this.$message('请先填写客户公司')
      window.open(`${window.frontend}/#/addHr/${this.company._id}`, '_blank')
    },
    gotoAddCompany() {
      window.open(`${window.frontend}/#/NewAddCompany?${this.inputCompany && 'companyName='+this.inputCompany}`, '_blank')
    },
    gotoRadish(rid) {
      window.open(`${window.frontend}/#/radish-detail-blank/${rid}`, '_blank')
    },
    async jobNameQuerySearch(queryString, cb) {
      const results = queryString ? await this.searchJobName(queryString) : []
      cb(results)
    },
    async searchJobName(name) {
      const res = await app.service('project').getRecommendJobNameAndCate({ keyword: name })
      if (res.status !== 'success') return []
      const jobs = res.data.职位 || []
      // const sliceJobs = jobs.slice(0, 10)
      this.recommendCateObj = res.data.推荐职能模块 || {}
      let keyCate = []
      res.data.关键词职能模块.forEach((c) => {
        keyCate = keyCate.concat(c.split('、'))
      })
      keyCate = Array.from(new Set(keyCate))
      if (keyCate && keyCate.length > 0) {
        const val = keyCate[0]
        this.$set(this.formData, '职能模块', val)
        this.$message(`根据岗位名称已为您匹配职能模块【${val}】`)
      } else {
        this.$set(this.formData, '职能模块', '')
      }
      return jobs.map((j) => ({ value: j }))
    },
    jobNameHandleSelect(item) {
      if (this.recommendCateObj[item.value] && this.recommendCateObj[item.value].length > 0) {
        const val = this.recommendCateObj[item.value][0]
        this.$set(this.formData, '职能模块', val)
        this.$message(`根据岗位名称已为您匹配职能模块【${val}】`)
      }
    },
    submit() {
      if (this.submiting) return this.$message('正在解析中，请稍候')
      if (Object.values(this.formData).every(dt=>(!dt || dt.length == 0))) return this.$message('您没有填写任何内容')
      this.submiting = true
      this.$router.push({name: 'createProject20'})
      this.$nextTick(()=>{
        if (this.$route.name == 'createProject20' && app.root.$refs.main) {
          this.intoPage()
        } else {
          setTimeout(()=>{
            if (this.$route.name == 'createProject20' && app.root.$refs.main) {
              this.intoPage()
            } else {
              setTimeout(()=>{
                if (this.$route.name == 'createProject20' && app.root.$refs.main) {
                  this.intoPage()
                }
              }, 3000)
            }
          }, 2000)
        }
      })
    },
    intoPage() {
      app.root.$refs.main.initProject(this.formData)
      this.$nextTick(()=>{
        const cbtn = document.querySelector('.el-message-box__close')
        // console.log(111111, cbtn)
        cbtn && cbtn.click()
      })
      this.formData = {}
      localStorage.removeItem(this.componentName)
      this.submiting = false
      this.$emit('closeTpl', {msg: '小阿已为您解析并自动填写到页面中'})
    },
    getToSaveProject() {
      const copyProject = window._.cloneDeep(this.formData)
      copyProject.客户开发 = [copyProject.客户开发]
      copyProject.对接hr = [copyProject.对接hrId]
      copyProject.项目成员 = [app.user.account]
      const bixuTags = ['职能模块', '细分职能', '擅长方向', '地域', '目标行业', '平台', '职级', '业绩']
      const youxianTags = ['学历要求', '倾向学历', '工作年限', '标签']
      const bixu = []
      const youxian = []
      bixuTags.forEach(label => {
        if (copyProject[label]) {
          if (Array.isArray(copyProject[label])) {
            copyProject[label].forEach(tag => {
              bixu.push({ label, tag, type: '必须' })
            })
          } else {
            bixu.push({ label, tag: copyProject[label], type: '必须' })
          }
        }
      })
      youxianTags.forEach(label => {
        if (copyProject[label]) {
          if (label == '标签') {
            copyProject[label].forEach(tag => {
              const realLabel = Object.keys(inputOptions).find(field => inputOptions[field].includes(tag))
              youxian.push({ label: realLabel, tag, type: '优先' })
            })
          } else if (label == '倾向学历') {
            copyProject[label].forEach(tag => {
              youxian.push({ label, tag, type: '优先' })
            })
          } else if (label == '学历要求') {
            youxian.push({ label, tag: copyProject.学历要求, type: '优先' })
          } else if (label == '工作年限') {
            youxian.push({ label, tag: `${copyProject.工作年限[0]}--${copyProject.工作年限[1]}`, type: '优先' })
          }
        }
      })
      copyProject.标签分类 = {
        必须: bixu,
        优先: youxian,
        其他: [],
      }
      return copyProject
    },
    async save() {
      // console.log(this.formData)
      if (this.submiting) return this.$message('正在解析中，请稍候')
      if (!this.formData.客户公司) return this.$message('请填写客户公司')
      if (!this.formData.客户开发) return this.$message('请填写客户开发')
      if (!this.formData.项目名称) return this.$message('请填写岗位名称')
      if (!this.formData.对接hrId) return this.$message('请填写企业联系人')
      if (!this.formData.地域 || this.formData.地域.length == 0) return this.$message('请填写工作地点')
      try {
        this.submiting = true
        const toSaveProject = this.getToSaveProject()
        const project = await window.app.service('project').insert(toSaveProject)
        if (project && project._id) {
          await app.getProjects()
          if (this.formData.项目名称 && this.formData.职能模块) {
            await app
              .service('project')
              .insertRecommendCate({ 关键词: this.formData.项目名称, 职能模块: this.formData.职能模块 })
          }
          localStorage.removeItem(this.componentName)
          // 如果hr不在hr 添加
          const hr = this.company.企业对接联系人.find(q => q._id == this.formData.对接hrId)
          if (hr && hr.type == '其他') {
            await app.service('company').addCompanyHr({cid: this.company._id, rid: this.formData.对接hrId})
          }
          this.$emit('closeTpl', {msg: '小阿已为您解析并新建项目', other: {msgType:'new', pid: project._id, 项目名称: project.项目名称}})
        }
        this.submiting = false
      } catch (e) {
        this.$message.error(`项目创建失败 : ${e.message}`)
        console.error(e)
      }
    },
    initData(defaultForm) {
      // console.log('4=====', JSON.stringify(defaultForm))
      this.activeTabName = '1'
      this.cateRenzhi = ''
      this.jingduiLoading = false
      this.liuruList = []
      this.paimingList = []
      this.temporaryCvInfo = []
      this.cvInfoLoading = false
      this.activeCateTable = {}
      this.activeCateTablCate = ''
      this.salaryActive = 'com'
      this.salaryActive2 = 'cate'
      this.formData = defaultForm || {地域:[]}
      if (this.formData.客户公司) {
        this.selectCompany({简称: this.formData.客户公司})
      }
    },

    async loadCateRenzhi() {
      if (this.company._id && this.formData.职能模块) {
        const res = await app.service('company').getComCateCognition(this.company._id)
        const item = res.data.find(dt => dt.职能模块 == this.formData.职能模块)
        this.cateRenzhi = item && item.职能模块认知 ? item.职能模块认知 : ''
      } else {
        this.cateRenzhi = ''
      }
    },
    openCompany(id) {
      window.open(`${window.frontend}/#/company/${id}`, '_blank')
    },
    async loadJingDui() {
      try {
        const { company } = this
        if (!company._id) return
        this.jingduiLoading = true
        const now = new Date()
        const m = now.getMonth() + 1
        const d = now.getDate()
        const y = now.getFullYear()
        const date = { $gte: `${y - 1}-01-01`, $lte: `${y}-12-31` }
        // const date = { $gte: `${y - 1}-${m < 10 ? `0${  m}` : m}-${d < 10 ? `0${  d}` : d}`, $lte: `${y}-${m < 10 ? `0${  m}` : m}-${d < 10 ? `0${  d}` : d}` }
        let liuruRes
        if (company.行业 === '私募股权（PEVC）') {
          liuruRes = await app.service('statistics').getPevcFlowGraphy({ 公司: company.简称 })
        } else {
          liuruRes = await app
            .service('statistics')
            .getFlowGraphy({ 公司: company.公司名称, 时间段: date })
        }
        if (liuruRes.status === 'success') {
          const { nodes, linkList, transfer } = liuruRes.data
          const companyInNode = nodes.find(item=>[company.公司名称, company.简称].includes(item.name) && item.category === 'in')
          const filterLinkList = linkList.filter(v=>`${v.target}`===`${companyInNode&&companyInNode.id}`)
          const nodeIds = filterLinkList.map(v=>`${v.source}`)

          this.liuruList = nodes
            .filter((item) => nodeIds.includes(`${item.id}`))
            .sort((a, b) => a.count < b.count ? 1 : -1)
            .splice(0, 10)
          const countIn = {}
          const companyNames = this.liuruList.map(v=>v.name)
          transfer.forEach(radish => {
            if ([company.公司名称, company.简称].includes(radish.目标公司)&&companyNames.includes(radish.来源公司)) {
              if (!countIn[radish.来源公司]) countIn[radish.来源公司] = []
              countIn[radish.来源公司].push(radish)
            }
          })
          this.liuruDetail = countIn
        } else {
          this.liuruList = []
          this.liuruDetail = {}
        }
        if (company.行业 && company.排名) {
          const paimingRes1 = await app.service('company').getCompanySimpleList({
            query: {行业: company.行业, 排名: {$lt: company.排名}},
            sort: {排名: -1},
            limit: 5
          })
          const paimingRes2 = await app.service('company').getCompanySimpleList({
            query: {行业: company.行业, 排名: {$gt: company.排名}},
            sort: {排名: 1},
            limit: 5
          })
          let paimingList = []
          if (paimingRes1.status === 'success') {
            paimingList = paimingList.concat(paimingRes1.data.filter(item=>item.简称 !== company.简称))
          }
          if (paimingRes2.status === 'success') {
            paimingList = paimingList.concat(paimingRes2.data.filter(item=>item.简称 !== company.简称))
          }
          this.paimingList = paimingList
        }
        this.jingduiLoading = false
      } catch (e) {
        console.error(e)
      }
    },
    async loadCvInfo() {
      this.cvInfoLoading = true
      if (this.formData.客户公司) {
        const query = {
          projectQuery: {
            客户公司: {
              $regex: this.formData.客户公司.trim(),
              $options: 'ig',
            },
          },
          radishProjectQuery: {
            $or: [
              {
                '状态.tag': '面试',
                '状态.detail': '终面',
              },
              {
                '状态.tag': 'offer谈判',
                '状态.detail': {
                  $nin: ['淘汰', '放弃'],
                },
              },
              {
                '状态.tag': 'offer',
                '状态.detail': {
                  $nin: ['淘汰', '放弃'],
                },
              },
              {
                '状态.tag': '到岗',
                '状态.detail': {
                  $nin: ['淘汰', '放弃'],
                },
              },
              {
                '状态.tag': '过保',
                '状态.detail': {
                  $nin: ['淘汰', '放弃'],
                },
              },
            ],
          },
        }
        const res1 = await app.service('file').searchCvInfoV2({ query, limit: 100 })
        if (res1.status === 'success') {
          let temporaryCvInfo = res1.data.data
          if (this.formData.职能模块) {
            temporaryCvInfo.sort((a, b) => {
              const isA = a.radish && a.radish.职能模块 && a.radish.职能模块.includes(this.formData.职能模块)
              const isB = b.radish && b.radish.职能模块 && b.radish.职能模块.includes(this.formData.职能模块)
              if (isA && isB) {
                return a.状态.detail == '终面' && b.状态.detail != '终面' ? 1 : -1
              } else if (isB) {
                return 1
              }
              return -1
            })
          }
          this.temporaryCvInfo = temporaryCvInfo.filter(dt=>dt.radish).map(dt=>{
            return Object.assign({
              项目名称: dt.project.项目名称,
              rid: dt.rid,
              pid: dt.pid,
              offer: dt.offer,
            }, dt.radish)
          })
        } else {
          this.temporaryCvInfo = []
        }
      } else {
        this.temporaryCvInfo = []
      }
      this.cvInfoLoading = false
    },
    showRadish(id) {
      window.open(`${window.frontend}/#/radish-detail-blank/${id}`, '_blank')
    },
    getArrVal(item, field) {
      return item[field] && Array.isArray(item[field])?item[field].join('、'):''
    },
    loadMoney() {
      try {
        const table = this.company.categoryMoneyTable
        if (table) {
          const cates = Object.keys(table)
          if (cates.length > 0) {
            this.activeCateTable = table[cates[0]]
            this.activeCateTablCate = cates[0]
          } else {
            this.$message('该公司暂无薪酬信息')
          }
          this.$refs.RadishesMoney && this.$refs.RadishesMoney.loadData()
        }
      } catch (e) {
        console.error(e)
      }
    },
    chooseCate(tab, event) {
      this.activeCateTable = this.company.categoryMoneyTable[tab.name]
      this.activeCateTablCate = tab.name
    },
    loadSalary() {
      if (this.company.行业 && this.formData.职能模块) {
        this.$nextTick(()=>{
          this.$refs.CategoryMoney && this.$refs.CategoryMoney.loadSalary()
          this.$refs.RadishesMoney2 && this.$refs.RadishesMoney2.loadData()
        })
      }
    },
    changeCate() {
      this.loadCateRenzhi()
      this.loadSalary()
    },
    handleSelectHr(item) {
      const hr = this.company.企业对接联系人.find(q => q._id == item)
      if (hr && hr.type == '其他') {
        this.$confirm(`${hr.姓名}非当前客户公司的对接hr，项目创建成功后，会将其添加为该公司的对接hr`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$refs.hrselect.blur()
        }).catch(() => {
          this.$refs.hrselect.blur()
          this.formData.对接hrId = ''
        });
      } else {
        this.$refs.hrselect.blur()
      }
    },
  }
}
</script>
<style>
  .hoveredhr-popover {
    position: absolute;
    top: 40px;
    left: 100%;
    z-index: 2000;
    max-height: 600px;
    overflow: auto;
    width: 100%;
    padding: 10px 20px;
    border: 1px solid #eaeefb;
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
    font-size: 12px;
    line-height: normal;
  }
  .zn-project-left {
    position: fixed;
    top: 60px;
    bottom: 0;
    left: 0;
    width: 40%;
    background-color: #fff;
    border: 1px solid #eee;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  }
  .zn-project-left>.el-tabs {
    position: absolute;
    width: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    padding: 50px 10px;
    display: flex;
    flex-direction: column;
  }
  .zn-project-left .el-tabs__header {
    flex: 0
  }
  .zn-project-left>.el-tabs>.el-tabs__content {
    flex: 1;
    overflow-y: auto;
  }

  .cv-info-dia-td-dot {
    display: flex;
  }
  .cv-info-dia-td-dot>span {
    display: inline-block;
    flex: none;
    text-align: right;
    color: #aaa;
  }
  .cv-info-dia-td-dot>div{
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #2478b5;
    padding: 0 5px;
  }
  .cv-info-dia-table>tr>th,.cv-info-dia-table>tr>td {
    border-bottom: 1px solid #eee;
    padding: 5px 0;
    line-height: 1.5;
  }
  .cv-info-dia-table>tr>th {
    color: #888;
  }
  .cv-info-dia-table>tr:hover {
    background: #eee;
    cursor: pointer;
  }
</style>
